function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaderboardChange = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = require("./style");
var _SVG = require("../../../SVG");
var _View = require("../../../View");
var _reactNative = require("react-native-web");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var LeaderboardChange = exports.LeaderboardChange = (0, _react.memo)(function (_ref) {
  var value = _ref.value,
    unit = _ref.unit;
  var _useStyles = (0, _style.useStyles)(),
    styles = _useStyles.styles;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var changeIcon = function changeIcon() {
    if (value > 0) {
      return (0, _jsxRuntime.jsx)(_SVG.SVG.Svg, {
        style: {
          width: 17,
          height: 18,
          transform: [{
            rotate: '180deg'
          }]
        },
        viewBox: "0 0 17 18",
        fill: "#3a804e",
        testID: "LeaderboardChangePositive",
        title: "up icon icon",
        children: (0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
          d: "M8.41389 18L0.655273 10.125H5.08877L5.08877 0L11.739 0L11.739 10.125H16.1725L8.41389 18Z"
        })
      });
    } else if (value < 0) {
      return (0, _jsxRuntime.jsx)(_SVG.SVG.Svg, {
        style: {
          width: 17,
          height: 18
        },
        viewBox: "0 0 17 18",
        fill: "#c44170",
        testID: "LeaderboardChangeNegative",
        title: "down arrow icon",
        children: (0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
          d: "M8.41389 18L0.655273 10.125H5.08877L5.08877 0L11.739 0L11.739 10.125H16.1725L8.41389 18Z"
        })
      });
    } else {
      return (0, _jsxRuntime.jsx)(_View.View, {
        style: styles.leaderboardChangeIconEqual,
        testID: "LeaderboardChangeNeutral",
        accessibilityLabel: "neutral icon"
      });
    }
  };
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: styles.leaderboardChangeWrapper,
    testID: "LeaderboardChange",
    children: [(0, _jsxRuntime.jsx)(_View.View, {
      style: styles.leaderboardChangeIconWrapper,
      children: changeIcon()
    }), (0, _jsxRuntime.jsxs)(_reactNative.Text, {
      textBreakStrategy: "simple",
      children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
        textBreakStrategy: "simple",
        style: styles.leaderboardChangeValue,
        children: t('format:number', {
          value: value
        })
      }), unit && (0, _jsxRuntime.jsx)(_reactNative.Text, {
        textBreakStrategy: "simple",
        style: styles.leaderboardChangeUnit,
        testID: "LeaderboardChangeUnit",
        children: unit
      })]
    })]
  });
});